module.exports = __webpack_public_path__ + "static/media/vote-yea.3f4ee537.svg";